import { h, render, Component } from 'preact';
import { Router } from 'preact-router';
import { Link } from 'preact-router/match';
import { translate } from 'react-i18next';

import Button from '../Button.js';

class VIP extends Component {

	render() {
		const { t } = this.props;
		return (
      <div className="view-VIP">
				<h1>{t('VIP Chat Support')}</h1>
				<div className="status-container">
					<h4>{t('Status:')}</h4>
					<h4 className={this.props.chatActive ? 'green' : 'red'}>{this.props.chatActive ? t('Online') : t('Offline')}</h4>
				</div>
				<p>{t('We have agents available to speak with you! Please click below to enter our chat window in order to receive assistance with any questions you may have!')}</p>
				{this.props.chatActive ?
					<Button
						color="blue true"
	          copy={t('Chat VIP Support')}
	          onClick={() => liveagent.startChat('573410000008luG')} /> : 
					<Button
						color="blue false"
	          copy={t('Chat VIP Support')} />}
			</div>
		);
	}
}

export default translate(['common'], { withRef: true })(VIP);



// WEBPACK FOOTER //
// ./components/views/VIP.js